import { BorderNoneIcon } from './BorderNoneIcon';

/**
 * author: Google
 * id F6333BD9-AC00-428D-B8A8-FA3B9187487F
 * name border-none
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/border-none.svg
 * tags
 * - Text / Content / Format 
 */
export const BorderClearIcon = BorderNoneIcon;
export default BorderClearIcon